import React from "react";
import { STWrapperModal, STModal } from "./styles";

interface IProps {
  width: number;
  isOpened: boolean;
  onClose: () => void;
}

export class SimpleModal extends React.Component<IProps> {
  render() {
    return (
        <STModal            
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={this.props.isOpened}
            onClose={this.props.onClose}
      >
            <STWrapperModal width={this.props.width} className={"custom-expired-session-modal"}>
          {this.props.children}
        </STWrapperModal>
      </STModal>
    );
  }
}
